export const SNACKBAR_SUCCESS = 'SNACKBAR_SUCCESS';
export const SNACKBAR_ERROR = 'SNACKBAR_ERROR';
export const SNACKBAR_CLEAR = 'SNACKBAR_CLEAR';

export const showErrorSnackbar = (message) => (dispatch) => {
  dispatch({ type: SNACKBAR_ERROR, message });
};
export const showSuccessSnackbar = (message) => (dispatch) => {
  dispatch({ type: SNACKBAR_SUCCESS, message });
};
export const clearSnackbar = () => (dispatch) => dispatch({ type: SNACKBAR_CLEAR });
